import { LoadingState } from '../../components/feedback/LoadingState'
import { activityFetch as fetch } from '../../components/feedback/requestActivity'
import { titleTheme, pageTheme, headerTheme, contentTheme, subTheme, cardTheme } from '../../components/consoleTheme'
import NodeSetupGuide from '../../components/NodeSetupGuide'

import { useState, useEffect } from "react"
import styled from "styled-components"
import { Plus, Globe, Trash2, Copy, Check, RefreshCw, Server, ChevronDown, ChevronRight, Download, Monitor, Terminal } from "lucide-react"

// 코디네이터 API (/api/vpn) — 같은 오리진(skynet.re.kr)에서 서빙되므로 상대경로
const API = "/api/vpn"
const AGENT_SERVER = "https://skynet.re.kr"

function getToken() {
  return sessionStorage.getItem("token") || localStorage.getItem("token")
}
function authHeaders(json = true) {
  const headers = {}
  if (json) headers["Content-Type"] = "application/json"
  const token = getToken()
  if (token) headers["Authorization"] = `Bearer ${token}`
  return headers
}

const PageContainer = styled.div`
  ${pageTheme}

  padding: 0;
  background: #f8fafc;
  min-height: 100vh;
  text-align: left;
`
const Header = styled.header`
  ${headerTheme}

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  @media(max-width:768px){padding:1rem;flex-wrap:wrap;gap:.75rem;align-items:flex-start;}
`
const Title = styled.h1`
 ${titleTheme}

  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
`
const Sub = styled.p`
  ${subTheme}

  margin: 0.25rem 0 0;
  font-size: 0.8rem;
  color: #94a3b8;
`
const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  cursor: pointer;
  ${(p) =>
    p.primary
      ? `background:var(--accent);color:#fff;border:none;&:hover{background:#115855;}`
      : `background:#fff;color:#64748b;border:1px solid #e2e8f0;&:hover{background:#f8fafc;}`}
`
const ContentContainer = styled.div`
  ${contentTheme}

  padding: 2rem;
  @media(max-width:768px){padding:1rem;}
`
const SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
const Card = styled.div`
  ${cardTheme}

  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  margin-bottom: 1.5rem;
  overflow: hidden;
`
const RowHead = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 1.2fr 0.8fr 1.4fr;
  padding: 0.85rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 600;
  color: #475569;
  font-size: 0.85rem;
  @media(max-width:768px){display:none;}
`
const Row = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 1.2fr 0.8fr 1.4fr;
  padding: 0.9rem 1.5rem;
  border-bottom: 1px solid #f1f5f9;
  align-items: center;
  &:last-child { border-bottom: none; }
  @media(max-width:768px){
    grid-template-columns:minmax(0,1fr);gap:.65rem;padding:1rem;
    border-bottom:8px solid #f8fafc;
    > *{min-width:0;overflow-wrap:anywhere;}
    > [data-label]::before{content:attr(data-label);display:block;margin-bottom:.2rem;color:#94a3b8;font-size:.7rem;font-weight:600;}
  }
`
const NameCell = styled.div`
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
`
const Mono = styled.code`
  font-family: ui-monospace, Menlo, Consolas, monospace;
  font-size: 0.82rem;
  color: #334155;
`
const IconBtn = styled.button`
  background: none;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 4px 8px;
  cursor: pointer;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.78rem;
  &:hover { color: var(--accent); border-color: var(--accent); }
`
const PeerWrap = styled.div`
  background: #f8fafc;
  padding: 1rem 1.5rem 1.25rem;
  border-bottom: 1px solid #f1f5f9;
`
const InstallBox = styled.div`
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-family: ui-monospace, Menlo, Consolas, monospace;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  overflow-x: auto;
`
const PeerTable = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
`
const PeerHead = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr 0.8fr 1.2fr 0.5fr;
  padding: 0.6rem 1rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
  @media(max-width:768px){display:none;}
`
const PeerRow = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr 0.8fr 1.2fr 0.5fr;
  padding: 0.6rem 1rem;
  font-size: 0.82rem;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;
  &:last-child { border-bottom: none; }
  @media(max-width:768px){
    grid-template-columns:minmax(0,1fr);gap:.5rem;padding:1rem;
    > *{min-width:0;overflow-wrap:anywhere;}
    > [data-label]::before{content:attr(data-label);display:block;margin-bottom:.15rem;color:#94a3b8;font-size:.7rem;font-weight:600;}
  }
`
const DeviceHead = styled(PeerHead)`
  grid-template-columns: 1.5fr 1fr .7fr 1.3fr 1fr;
`
const DeviceRow = styled(PeerRow)`
  grid-template-columns: 1.5fr 1fr .7fr 1.3fr 1fr;
`
const Dot = styled.span`
  display: inline-block;
  width: 8px; height: 8px; border-radius: 50%;
  margin-right: 6px;
  background: ${(p) => (p.online ? "#22c55e" : "#cbd5e1")};
`
const Empty = styled.div`
  padding: 2rem;
  text-align: center;
  color: #94a3b8;
`
const CreateRow = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f1f5f9;
  input {
    flex: 1;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    outline: none;
    &:focus { border-color: var(--accent); }
  }
`

const NetworkDashboard = () => {
  const [meshes, setMeshes] = useState([])
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState("")
  const [creating, setCreating] = useState(false)
  const [newName, setNewName] = useState("")
  const [expanded, setExpanded] = useState(null)
  const [peers, setPeers] = useState({})
  const [allPeers, setAllPeers] = useState([])
  const [devicesLoading, setDevicesLoading] = useState(true)
  const [devicesError, setDevicesError] = useState("")
  const [copied, setCopied] = useState(null)

  const loadMeshes = async () => {
    setLoading(true)
    setErr("")
    try {
      const res = await fetch(`${API}/mesh`, { headers: authHeaders(false), credentials: "include" })
      if (res.status === 401 || res.status === 403) {
        setErr("로그인이 필요합니다.")
        setMeshes([])
        return
      }
      const data = await res.json()
      setMeshes(data.meshes || [])
    } catch (e) {
      setErr("VPC 목록을 불러오지 못했습니다.")
    } finally {
      setLoading(false)
    }
  }

  const loadAllPeers = async () => {
    setDevicesLoading(true)
    setDevicesError("")
    try {
      const res = await fetch(`${API}/peers`, { headers: authHeaders(false), credentials: "include" })
      if (!res.ok) throw new Error(res.status === 401 || res.status === 403 ? "로그인이 필요합니다." : "컴퓨터 목록을 불러오지 못했습니다.")
      const data = await res.json()
      setAllPeers(Array.isArray(data.peers) ? data.peers : [])
    } catch (e) {
      setAllPeers([])
      setDevicesError(e.message || "컴퓨터 목록을 불러오지 못했습니다.")
    } finally {
      setDevicesLoading(false)
    }
  }

  const isOnline = (peer) => peer.status === "online" && peer.last_seen &&
    Date.now() - new Date(peer.last_seen).getTime() < 90000

  useEffect(() => {
    loadMeshes()
    loadAllPeers()
  }, [])

  const createMesh = async () => {
    const name = newName.trim()
    if (!name) return
    try {
      const res = await fetch(`${API}/mesh`, {
        method: "POST",
        headers: authHeaders(),
        credentials: "include",
        body: JSON.stringify({ mesh_name: name }),
      })
      if (!res.ok) {
        const d = await res.json().catch(() => ({}))
        alert("생성 실패: " + (d.error || res.status))
        return
      }
      setNewName("")
      setCreating(false)
      loadMeshes()
    } catch (e) {
      alert("생성 실패: " + e.message)
    }
  }

  const loadPeers = async (id) => {
    try {
      const res = await fetch(`${API}/mesh/${id}/peers`, { headers: authHeaders(false), credentials: "include" })
      const data = await res.json()
      setPeers((p) => ({ ...p, [id]: data.peers || [] }))
    } catch (e) {
      setPeers((p) => ({ ...p, [id]: [] }))
    }
  }

  const toggleExpand = (id) => {
    if (expanded === id) {
      setExpanded(null)
    } else {
      setExpanded(id)
      loadPeers(id)
    }
  }

  const deletePeer = async (peerId, meshId) => {
    if (!window.confirm("이 장비를 VPC에서 제거할까요?")) return
    try {
      const res = await fetch(`${API}/agents/${peerId}`, { method: "DELETE", headers: authHeaders(false), credentials: "include" })
      if (!res.ok) {
        alert("제거 실패")
        return
      }
      loadPeers(meshId)
      loadMeshes()
    } catch (e) {
      alert("제거 실패: " + e.message)
    }
  }

  const copyText = (txt, key) => {
    const ok = () => {
      setCopied(key)
      setTimeout(() => setCopied((c) => (c === key ? null : c)), 1500)
    }
    // iframe/권한 제한 환경 폴백 (execCommand 는 clipboard 권한 불필요)
    const fallback = () => {
      try {
        const ta = document.createElement("textarea")
        ta.value = txt
        ta.style.position = "fixed"
        ta.style.top = "0"
        ta.style.opacity = "0"
        document.body.appendChild(ta)
        ta.focus()
        ta.select()
        document.execCommand("copy")
        document.body.removeChild(ta)
        ok()
      } catch (e) {}
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(txt).then(ok).catch(fallback)
      } else {
        fallback()
      }
    } catch (e) {
      fallback()
    }
  }

  return (
    <PageContainer>
      <Header>
        <div>
          <Title>가상 네트워크 (VPC)</Title>
          <Sub>에이전트를 설치하고 토큰을 입력하면 같은 VPC끼리 LAN처럼 묶입니다.</Sub>
        </div>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <Button onClick={() => { loadMeshes(); loadAllPeers() }} title="새로고침">
            <RefreshCw size={16} /> 새로고침
          </Button>
          <Button primary onClick={() => setCreating((v) => !v)}>
            <Plus size={16} /> VPC 만들기
          </Button>
        </div>
      </Header>

      <ContentContainer>
        <NodeSetupGuide section="network"/>
        <SectionTitle>
          <Download size={18} /> 에이전트 다운로드
        </SectionTitle>
        <Card style={{ padding: "1.25rem 1.5rem" }}>
          <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginBottom: "1rem" }}>
            <a href="/download/skynetmesh-win-x64.exe" download style={{ textDecoration: "none" }}>
              <Button primary><Monitor size={16} /> Windows (.exe)</Button>
            </a>
            <a href="/download/skynetmesh-linux-x64" download style={{ textDecoration: "none" }}>
              <Button><Terminal size={16} /> Linux 바이너리</Button>
            </a>
          </div>
          <div style={{ fontSize: "0.85rem", color: "#64748b", marginBottom: "0.4rem" }}>
            Windows 한 줄 설치 — <strong>관리자 PowerShell</strong>에 붙여넣기 (토큰은 실행 중 물어봄):
          </div>
          <InstallBox>
            <span>irm https://skynet.re.kr/download/install.ps1 | iex</span>
            <IconBtn
              style={{ background: "#1e293b", color: "#e2e8f0", borderColor: "#334155", flexShrink: 0 }}
              onClick={() => copyText("irm https://skynet.re.kr/download/install.ps1 | iex", "instwin")}
            >
              {copied === "instwin" ? <Check size={14} /> : <Copy size={14} />}
              {copied === "instwin" ? "복사됨" : "복사"}
            </IconBtn>
          </InstallBox>
          <div style={{ fontSize: "0.85rem", color: "#64748b", margin: "0.6rem 0 0.4rem" }}>
            Linux 한 줄 설치 (WireGuard 도구까지 자동):
          </div>
          <InstallBox>
            <span>curl -fsSL https://skynet.re.kr/download/install.sh | sudo bash</span>
            <IconBtn
              style={{ background: "#1e293b", color: "#e2e8f0", borderColor: "#334155", flexShrink: 0 }}
              onClick={() => copyText("curl -fsSL https://skynet.re.kr/download/install.sh | sudo bash", "inst")}
            >
              {copied === "inst" ? <Check size={14} /> : <Copy size={14} />}
              {copied === "inst" ? "복사됨" : "복사"}
            </IconBtn>
          </InstallBox>
          <p style={{ fontSize: "0.8rem", color: "#94a3b8", margin: "0.75rem 0 0" }}>
            터널 엔진·드라이버는 에이전트에 <strong>내장</strong>이라 별도 설치 불필요. 연결은 <strong>TLS 443</strong>이라 UDP 막힌 방화벽도 통과.
            앤츠톡 데스크탑에선 <strong>플러그인 탭 → SkynetMesh</strong>에서 토큰만 붙여넣고 [연결]하면 더 간단합니다.
          </p>
        </Card>

        <SectionTitle>
          <Monitor size={18} /> 관리 대상 컴퓨터
        </SectionTitle>
        <Card>
          {!devicesLoading && !devicesError && <div style={{ padding: "0.85rem 1rem", color: "#475569", fontSize: "0.85rem", borderBottom: "1px solid #e2e8f0" }}>
            에이전트 등록 {allPeers.length}건 · 최근 접속 {allPeers.filter(isOnline).length}건
            <span style={{ marginLeft: 8, color: "#94a3b8" }}>VPC별 등록 건수이며, 최근 90초 내 접속을 온라인으로 표시합니다.</span>
          </div>}
          <DeviceHead>
            <span>컴퓨터</span><span>VPC</span><span>OS</span><span>상태 / 마지막 접속</span><span>가상 IP</span>
          </DeviceHead>
          {devicesLoading ? <LoadingState label="불러오는 중…" /> : devicesError ? <Empty>{devicesError}</Empty> :
            allPeers.length === 0 ? <Empty>등록된 컴퓨터가 없습니다. 아래 VPC에서 에이전트를 등록하세요.</Empty> :
              allPeers.map((peer) => {
                const online = isOnline(peer)
                return <DeviceRow key={peer.peer_id}>
                  <span data-label="컴퓨터" style={{ fontWeight: 600, color: "#1e293b" }}>{peer.hostname || "(이름없음)"}</span>
                  <span data-label="VPC">{peer.mesh_name || "-"}</span>
                  <span data-label="OS">{peer.os_type || "-"}</span>
                  <span data-label="상태 / 마지막 접속"><Dot online={online} />{online ? "온라인" : peer.last_seen ? `마지막 접속 ${new Date(peer.last_seen).toLocaleString("ko")}` : "미접속"}</span>
                  <Mono data-label="가상 IP">{peer.virtual_ip || "-"}</Mono>
                </DeviceRow>
              })}
        </Card>

        <SectionTitle>
          <Globe size={18} /> 내 VPC
        </SectionTitle>
        <Card>
          {creating && (
            <CreateRow>
              <input
                autoFocus
                placeholder="VPC 이름 (예: 회사망)"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && createMesh()}
              />
              <Button primary onClick={createMesh}>
                생성
              </Button>
              <Button onClick={() => { setCreating(false); setNewName("") }}>취소</Button>
            </CreateRow>
          )}
          <RowHead>
            <span>이름</span>
            <span>서브넷 (CIDR)</span>
            <span>장비</span>
            <span>가입 토큰</span>
          </RowHead>

          {loading ? (
            <LoadingState label="불러오는 중…" />
          ) : err ? (
            <Empty>{err}</Empty>
          ) : meshes.length === 0 ? (
            <Empty>아직 VPC가 없습니다. “VPC 만들기”로 첫 가상망을 생성하세요.</Empty>
          ) : (
            meshes.map((m) => (
              <div key={m.mesh_id}>
                <Row>
                  <NameCell onClick={() => toggleExpand(m.mesh_id)}>
                    {expanded === m.mesh_id ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                    <Globe size={16} /> {m.mesh_name}
                  </NameCell>
                  <Mono data-label="서브넷">{m.subnet_cidr}</Mono>
                  <span data-label="장비" style={{ color: "#475569" }}>{m.peer_count ?? 0}대</span>
                  <div>
                    <IconBtn onClick={() => copyText(m.join_token, `t${m.mesh_id}`)}>
                      {copied === `t${m.mesh_id}` ? <Check size={14} /> : <Copy size={14} />}
                      {copied === `t${m.mesh_id}` ? "복사됨" : "토큰 복사"}
                    </IconBtn>
                  </div>
                </Row>

                {expanded === m.mesh_id && (
                  <PeerWrap>
                    <InstallBox>
                      <span>skynetmesh register --server {AGENT_SERVER} --token-stdin</span>
                      <IconBtn
                        style={{ background: "#1e293b", color: "#e2e8f0", borderColor: "#334155", flexShrink: 0 }}
                        onClick={() => copyText(`skynetmesh register --server ${AGENT_SERVER} --token-stdin`, `c${m.mesh_id}`)}
                      >
                        {copied === `c${m.mesh_id}` ? <Check size={14} /> : <Copy size={14} />}
                        {copied === `c${m.mesh_id}` ? "복사됨" : "명령 복사"}
                      </IconBtn>
                    </InstallBox>

                    <PeerTable>
                      <PeerHead>
                        <span>호스트명</span>
                        <span>가상 IP</span>
                        <span>OS</span>
                        <span>상태 / 마지막 접속</span>
                        <span></span>
                      </PeerHead>
                      {(peers[m.mesh_id] || []).length === 0 ? (
                        <Empty style={{ padding: "1.25rem" }}>가입한 장비가 없습니다. 위 명령으로 에이전트를 설치하세요.</Empty>
                      ) : (
                        (peers[m.mesh_id] || []).map((p) => {
                          const online = p.status === "online" &&
                            p.last_seen && (Date.now() - new Date(p.last_seen).getTime() < 90000)
                          return (
                            <PeerRow key={p.peer_id}>
                              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <Server size={14} color="#64748b" /> {p.hostname || "(이름없음)"}
                              </span>
                              <Mono>{p.virtual_ip}</Mono>
                              <span style={{ color: "#64748b" }}>{p.os_type || "-"}</span>
                              <span style={{ color: "#475569" }}>
                                <Dot online={online} />
                                {online ? "온라인" : p.last_seen ? new Date(p.last_seen).toLocaleString("ko") : "미접속"}
                              </span>
                              <IconBtn
                                style={{ borderColor: "#fecaca", color: "#ef4444" }}
                                onClick={() => deletePeer(p.peer_id, m.mesh_id)}
                                title="제거"
                              >
                                <Trash2 size={14} />
                              </IconBtn>
                            </PeerRow>
                          )
                        })
                      )}
                    </PeerTable>
                  </PeerWrap>
                )}
              </div>
            ))
          )}
        </Card>
      </ContentContainer>
    </PageContainer>
  )
}

export default NetworkDashboard
